import { isArray, isFunction } from 'lodash'
import { getRowKeyIter } from '../../store/config/utils'

function isExpandable(treeProps, rowData, column, expandColumnKey) {
  const { children, hasChildren = 'hasChildren' } = treeProps
  return rowData[hasChildren] || (isArray(rowData[children]) && rowData[children].length > 0 && column.key === expandColumnKey)
}

export function createRow() {
  return {
    functional: true,
    name: 'TableRow',
    render(_, context) {
      const {
        columns = [],
        rowData = {},
        renderDataIndex,
        loadingRow,
        rowIndex,
        _index,
        showSelection,
        rowStyle,
        rowClassName = [],
        rowKey,
        depthMap,
        expandColumnKey,
        indentSize,
        iconSize,
        expandedRowKeys,
        onRowExpanded,
        treeProps,
        fixedRowsLength,
        rowHeight,
        offsetY,
        scrollTop,
        // events
        handleEvent,
      } = context.props
      const _rowKeyVal = getRowKeyIter(rowData, rowKey)
      const depth = depthMap[_rowKeyVal] || 0
      const [$slots] = context.children
      let ColumnCells = columns && columns.map((column) => {
        const columnIndex = column.originIndex
        const { placeholderSign } = column
        if (placeholderSign) {
          return $slots.cell({
            column,
            columnIndex,
            rowHeight,
            offsetY,
            rowIndex,
            scrollTop
          })
        }
        const expandable = isExpandable(treeProps, rowData, column, expandColumnKey)
        return $slots.cell({
          column,
          columns,
          columnIndex,
          rowData,
          renderDataIndex,
          depth,
          rowIndex,
          loading: loadingRow.includes(_rowKeyVal),
          expandIconProps: expandable
            ? {
              rowData,
              rowIndex,
              onExpand: onRowExpanded,
            } : undefined,
          indentSize,
          iconSize,
          expandColumnKey,
          expandedRowKeys,
          rowKey,
          handleEvent,
          _index,
          showSelection,
          rowHeight,
          offsetY,
          scrollTop
        })
      })
      if ($slots.row) {
        ColumnCells = isFunction($slots.row) ? $slots.row({
          cells: ColumnCells.map((node) => {
            if (isArray(node) && node.length === 1) {
              return node[0]
            }
            return node
          }),
          style: rowStyle,
          columns,
          rowHeight,
          showSelection
        }) : $slots.row
      }

      const index = rowIndex + (fixedRowsLength || 0)
      const mouseenter = ($event) => {
        handleEvent($event, { rowIndex: index, row: rowData, eventType: 'mouseenter', execRow: true })
      }
      const mouseleave = ($event) => {
        handleEvent($event, { rowIndex: index, row: rowData, eventType: 'mouseleave', execRow: true })
      }
      const rowClass = [
        'virtual-grid__inner__table__row',
        `row-depth-${depth}`,
        `row-${index}`,
        ...rowClassName
      ].filter(Boolean)
      return (
        <tr
          class={rowClass}
          style={rowStyle}
          onMouseenter={mouseenter}
          onMouseleave={mouseleave}
        >
          { ColumnCells }
        </tr>
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-table2/components/body/row.js